import { gql } from "graphql-tag";

export const memberAlternateGrid = gql`
  fragment Become_a_member_Member_alternate_grid on Become_a_memberBodyMemberalternategrid {
    type
    fields {
      item_title
      item_description
    }
    primary {
      id
      optional_icon
      subtitle
      paragraph
      image
      optional_image_alignment
      iframe_section
      media_alignment
      snooze_member_form
    }
  }
`;
